// removed by extract-text-webpack-plugin
module.exports = {"header":"header_header_1xVMn","middleBox":"header_middleBox_n5mG-","logo":"header_logo_2NVZB","menuList":"header_menuList_15ttr","account":"header_account_2JVyi","iconDengChu":"header_iconDengChu_NUE6-","userName":"header_userName_11d4y","navAction":"header_navAction_2FZTX"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/header/header.scss
// module id = 1573
// module chunks = 0